import AppConfig from '../config';

const { defaultLocale, supportedLocales } = AppConfig;

const getCurrentLocale = () => {
  if (typeof window !== 'undefined') {
    const localePath = window.location.pathname.split('/')[1];

    if (localePath && supportedLocales.includes(localePath)) {
      return localePath;
    }
  }

  return AppConfig.defaultLocale;
};

export const lang = getCurrentLocale();

export const translateLocal = (text, locale = lang) => {

  if (!text) {
    return '';
  }

  if (text[locale]) {
    return text[locale];
  }

  return text[defaultLocale];
};
